import { SecureService } from './secureService'
import { duration } from 'moment'
import { Config, env } from '../utilities/config'
import { Helpers } from '../utilities/helpers';
import { MotorService } from './motorService';

const INACTIVITY_PERION_CONFIG = {
  period: 3,
  unit: 'minutes',
}

const INACTIVITY_PERION = duration(INACTIVITY_PERION_CONFIG.period, INACTIVITY_PERION_CONFIG.unit).asMilliseconds()

const USER_INTERACTIONS_EVENTS = [
  'mousemove',
  'keypress',
  'touchstart',
  'scroll',
  'click',
  'change',
  'beforeunload',
  'load',
  'unload',
]

class _Service extends SecureService {
  constructor() {
    super()
    this.timeout = null
    this.fallbackTimeout = null
  }

  init = async () => {
    let agent
    const agentData = await Helpers.getInStorage('sales_agent', true)

    if (agentData) {
      agent = JSON.parse(agentData)
    }

    // Do not track activity for sales agents
    if (agent) return 

    this.activityTracker()
    this.start()
  }

  start = async () => {
    let agent
    const agentData = await Helpers.getInStorage('sales_agent', true)

    if (agentData) {
      agent = JSON.parse(agentData)
    }
    
    // Do not track activity for sales agents
    if (agent) return 

    this.timeout = setTimeout(() => {
      this.notify()
    }, INACTIVITY_PERION)
  }

  stop = () => {
    clearTimeout(this.timeout)
    this.timeout = null
  }

  reset = () => {
    if (this.timeout) { 
      this.stop()
      this.start()
    }
  }

  activityTracker = () => {
    USER_INTERACTIONS_EVENTS.forEach(activity => {
      addEventListener(activity, this.reset())
    })
  }

  destroy = () => {
    clearTimeout(this.timeout)
    clearTimeout(this.fallbackTimeout)

    this.timeout = null
    this.fallbackTimeout = null

    USER_INTERACTIONS_EVENTS.forEach(activity => {
      removeEventListener(activity, this.reset())
    })
  }

  notify = () => {
    const lead_params = {}
    return Promise.resolve()
    .then(() => {
      this.stop()
      this.destroy()
    })
    .then(async () => {
      // get user from localStorage
      const user = await Helpers.getAuthUser()
      const vehicle = JSON.parse(await Helpers.getInStorage('vehicle'))
      const cachedQuoteDetails = JSON.parse(await Helpers.getInStorage('cachedQuoteDetails'))

      if (!user) {
        return Promise.reject([
          500,
          'No user document found'
        ])
      }

      // determine user last page when sending lead
      const last_page = window.location.pathname
      Object.assign(lead_params, {
        user_id: user.id,
        user,
        vehicleDetails: vehicle ? {
          vehicle_id: vehicle.id,
          make: vehicle.make,
          model: vehicle.model,
          year: vehicle.year,
          registration: vehicle.registration,
        } : null,
        cachedQuoteDetails,
        last_page
      })
    })
    .then(async() => {
      // send request to server to notify user
      const res = await fetch(`${Config.services.lead.sendConnexLead}`, {
        method: 'POST',
        headers: {
          ...this.defaultHeaders,
          Authorization: this.generateAuthHeader(),
        },
        body: JSON.stringify(lead_params)
      })

      return res
    })
    .catch((error) => {
      if (env === 'development') {
        console.error('Error notifying user', error)
      }
    })
  }
}

const SmartDelayService = new _Service()
export default SmartDelayService
